import { useState } from "react";
import styles from "./css/findPaymentModal.module.css";
import axios from "../../services/axios-config";
import { IoIosCloseCircle } from "react-icons/io";
import { FaChevronRight } from "react-icons/fa";



export default function FindPaymentModal({show, onClose, onFind}){

    const [value, setValue] = useState(null);
    const [payer, setPayer] = useState(null);
    const [loading, setLoading] = useState(false);


    const handleFindPayment = async () => {
        try{
            setLoading(true);

            
            if(!value){
                return;
            }
            
            const res = await axios.get('/payments/find', {
                params: {
                    transactionId: value
                }
            })

            if(res.status == 200){
                setPayer(res.data.payload.payer);
            }

        } catch (error) {
            console.error('ERROR - FIND PAYMENT FUNCTION:', error);

        } finally {
            setLoading(false);
        }
    }

    const handleClose = () => {
        setValue(null);
        setPayer(null);
        onClose();
    }
    
    const handleOpenPayer = (data) => {
        handleClose();
        onFind(data);
    }



    if(show){
        return (
            <div className={styles.modalArea}>
                <div className={styles.overflow}/>
    
                <div className={styles.container}>
                    <button className={styles.closeButton} onClick={() => handleClose()}>
                        <IoIosCloseCircle size={23}/>
                    </button>
    
                    <h2 style={{marginTop: 10}}>Encontrar pagamento:</h2>
    
                    <div className={styles.inputArea}>
                        <input
                            type='text'
                            className={styles.input}
                            placeholder={'Buscar pelo código de transação'}
                            value={value}
                            onChange={({target: {value}}) => setValue(value)}
                        />
    
                        <button
                            className={styles.findPaymentButton}
                            onClick={() => handleFindPayment()}
                        >
                            <span style={{color: '#fff'}}>Buscar</span>
                        </button>
                    </div>
    
                    {payer ? (
                        <>
                            {loading ? (
                                <p style={{textAlign: 'center', marginTop: 25}}>Carregando...</p>
    
                            ) : (
                                <div className={styles.companyContainer}>
                                    <div>
                                        <p>{payer?.id} - {payer?.name}</p>

                                        <p style={{marginTop: 2, fontSize: 11, color: '#333', }}>{payer?.type == 'company' ? 'Empresa' : 'Usuário - CMV'}</p>

                                    </div>
            
                                    <button className={styles.selectCompanyButton} onClick={() => handleOpenPayer(payer)}>
                                        <FaChevronRight size={18} color="#fff"/>
                                    </button>
                                </div>
                            )}
                        </>
                    ) : (
                        <p style={{textAlign: 'center', marginTop: 25}}>Busque por pagamentos</p>
                    )}
                </div>
            </div>
        )
    }
}